module.exports = __webpack_public_path__ + "static/media/1.28b53c3b.svg";